export default __webpack_public_path__ + "static/media/janice-lin-yUIN4QWKCTw-unsplash.d211b855.jpg";